/*
  Series of functions which conditionally test whether JS attribution
  is required.
  Tests for cookie-based existing values and cookie consent integration.
*/

// Import utility classes for required functions
import ECSLeadUtils from './_ecs-attribution-parameters.js'
import ECSAttributionCookie from './_ecs-attribution-cookie.js'
import ECSAttributionApply from './_ecs-attribution-apply.js'

// Import provider classes for utilities
import ECSEntrataAttribution from './_ecs-provider-entrata.js'

const leadUtils = new ECSLeadUtils()
const cookieUtils = new ECSAttributionCookie()
const applyUtils = new ECSAttributionApply()
const providerUtils = getAttributionClassForProvider(attrPluginSettings.leadProvider)

// Function for providers that provide lead data via APIs
// Calls the API and builds the leadAttribution object
function prepareAttribution (_leadParams) {
  let leadAttribution = false

  if (['entrata'].includes(attrPluginSettings.leadProvider)) {
    // This provider provides lead data via an API, call the appropriate AJAX action to request
    const sourceAttributionRaw = leadUtils.runAttributionAjax(attrPluginSettings.leadProvider, 'picklist')
    const sourceAttribution = JSON.parse(sourceAttributionRaw).response
    leadAttribution = providerUtils.buildAttribution(attrPluginSettings, _leadParams, sourceAttribution)
  }

  return leadAttribution
}

// Function that tests new leads and applies attribution if lead data
// is well formed
function doLeadAttribution (_lead) {
  if (_lead == false) {
    console.warn('No matching lead found. Destroying attribution cookie...')
    cookieUtils.destroyAttributionCookie('ecsattr')
  } else {
    applyUtils.applyAttribution(attrPluginSettings, _lead, providerUtils)
    cookieUtils.setAttributionCookie(_lead, 60)
  }
}

function getAttributionClassForProvider (_provider) {
  switch (_provider) {
    case 'entrata':
      return new ECSEntrataAttribution()
    // case 'realpage':
    //   return new ECSRealPageAttribution()
    default:
      throw new Error('Attribution class not found for provider ' + _provider + '.')
  }
}

function parseConsent (_event) {
  let ecsCcConsent = false
  if (_event.detail.cookie.categories.length == 0 || (_event.detail.cookie.categories.length == 1 && _event.detail.cookie.categories.includes('necessary')) ) {
    // There either aren't any accepted categories,
    // or the only accepted category is "necessary", which for us
    // constitutes rejection
    ecsCcConsent = false
  } else if (_event.detail.cookie.categories.length >= 2) {
    ecsCcConsent = true
  }

  return ecsCcConsent
}

function doCookieConsentEvent (_event, _leadParams) {
  if (parseConsent(_event)) {
    // Cookie consent has been provided, do attribution
    // console.log('The Attribution plugin has detected that consent has been GRANTED.')
    const lead = prepareAttribution(_leadParams)
    doLeadAttribution(lead)
  } else {
    // Cookie consent has been DENIED, destroy attribution
    // console.log('The Attribution plugin has detected that consent has been DENIED.')
    cookieUtils.destroyAttributionCookie('ecsattr')
  }
}

function apiAttributionInit () {
  let ecsCcActive = false
  if (typeof ecs_cookie_consent_active !== 'undefined' && (ecs_cookie_consent_active ===true )) {
    ecsCcActive = true
  }
  const cookiePresent = cookieUtils.checkAttributionCookie('ecsattr')

  // Check Attribution on init
  if (cookiePresent) {
    // Attribution has already been stored
    console.log('An attribution cookie has been detected.')

    let lead = cookieUtils.processCookie('ecsattr')
    const params = leadUtils.getUrlParams(attrPluginSettings.leadProvider)
    const leadParams = providerUtils.testParamsForLeads(attrPluginSettings.leadProvider, params)

    // Check if there is a new lead present
    if (leadParams.active && (lead.leadParam.value != leadParams.value)) {
      // There is a new lead present
      console.log('There is an existing cookie, but also a NEW lead - update the lead.')

      lead = prepareAttribution(leadParams)

      // Delete the existing cookie, just in case
      cookieUtils.destroyAttributionCookie('ecsattr')
      doLeadAttribution(lead)
    } else {
      // There is a NOT a new lead present
      console.log('No lead param, or param matches existing lead - use the existing cookie lead data.')

      applyUtils.applyAttribution(attrPluginSettings, lead, providerUtils)
    }
  } else {
    // There is no cookie yet, run tests
    console.log('No attribution cookie detected, run tests.')

    const params = leadUtils.getUrlParams(attrPluginSettings.leadProvider)
    const leadParams = providerUtils.testParamsForLeads(attrPluginSettings.leadProvider, params)

    if (!leadParams.active) {
      console.log('No source attribution parameter was found in the URL. END')
      return
    }

    // There is marketing lead data present in the URL parameters, do tests
    console.log('A source attribution parameter was found in the URL.')

    // Test for cookie consent requirement
    if (ecsCcActive) {
      // Cookie consent script is enabled, wait for consent before doing work
      console.log('Cookie consent script present, waiting for events to bubble...')

      // 'Accept' event, which includes both standard acceptance and
      // 'necessary only' acceptance (DENIAL)
      window.addEventListener('cookieAccept', function (e) {
        doCookieConsentEvent(e, leadParams)
      })

      // 'Check' event, which includes full DENIAL
      window.addEventListener('cookieCheck', function (e) {
        doCookieConsentEvent(e, leadParams)
      })
    } else {
      // Cookie consent isn't required, just do the attribution
      const lead = prepareAttribution(leadParams)
      doLeadAttribution(lead)
    }
  }
}

if (attrPluginSettings.apiMode) {
  // API-based attribution has been requested in the CMS.
  // Begin the API attribution process
  jQuery(document).ready(function () {
    apiAttributionInit()
  })
}
